// A small, consistent "we couldn't load this" state with a retry, for pages
// whose data query failed. Without it, the common `if (isLoading || !data)
// return <Spinner/>` pattern turns a fetch error into a permanent spinner, and
// `data ?? []` turns it into a misleading "nothing here yet" empty state. Use
// this on the `isError` branch so a backend hiccup reads as an error, not as
// "empty" or "still loading".

import { Button } from '../design-system/index.js'

/**
 * Failed-query state with a "Reintentar" button. Render on the `isError` branch
 * of a page query so a fetch failure never shows as a spinner or empty state.
 */
export function QueryError({
  message = 'No pudimos cargar esta información.',
  onRetry,
}: {
  message?: string
  onRetry: () => void
}): JSX.Element {
  return (
    <div className="flex flex-col items-start gap-3 rounded-xl border border-line bg-surface p-6">
      <p className="text-[13px] text-text-2">{message}</p>
      <Button variant="secondary" onClick={onRetry}>
        Reintentar
      </Button>
    </div>
  )
}
